import { Component } from 'react';
import { Tab, Tabs } from "@mui/material";
import SwipeableViews from "react-swipeable-views";
import AppBar from "@mui/material/AppBar";
import MyEquipmentsEPI from '../../components/EPI/MyEquipmentsEPI'
import EquipmentsEPI from '../../components/EPI/EquipmentsEPI'
import withAuth from '../../components/withAuth';
import {compose} from "redux";
import {connect} from "react-redux";
import { setEquipmentsEPITabId, getMyEquipmentsEPI, getCoworkersEquipmentsEPI, getCommonAndUnaffectedEquipments } from "../../redux/epi/epiActions";
import './FollowupEquipmentsEPI.css';
import { getEmployeesByDepartment } from "../../redux/humanResources/humanResourcesActions";
import { deepCompare } from "../../utils";

class FollowupEquipmentsEPI extends Component {
    constructor(props){
        super(props);

        if(this.props.loggedEmployee && this.props.employeesOfCompany.length == 0) 
        {
            this.props.getEmployeesByDepartment([props.loggedEmployee.department_id.id], [props.loggedEmployee.company_id.id], props.activeUser);
        }
        if (this.props.employeesOfCompany && 
            this.props.employeesOfCompany.length > 0) 
        {
            if (!this.props.tabId) {
                this.props.getMyEquipmentsEPI(this.props.activeUser);
            }

            if (this.props.tabId) {
                this.props.getCoworkersEquipmentsEPI(this.props.activeUser, this.props.employeesOfCompany);
                this.props.getCommonAndUnaffectedEquipments(this.props.activeUser, this.props.loggedEmployee);       
            }            
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.loggedEmployee && prevProps.loggedEmployee !== this.props.loggedEmployee &&  this.props.employeesOfCompany.length == 0) 
        {
            this.props.getEmployeesByDepartment([this.props.loggedEmployee.department_id.id], [this.props.loggedEmployee.company_id.id], this.props.activeUser);
        }

        if (!deepCompare(prevProps.employeesOfCompany, this.props.employeesOfCompany) && 
            this.props.employeesOfCompany && 
            this.props.employeesOfCompany.length > 0) 
        {
            if (!this.props.tabId) {
                this.props.getMyEquipmentsEPI(this.props.activeUser);
            }

            if (this.props.tabId) {
                this.props.getCoworkersEquipmentsEPI(this.props.activeUser, this.props.employeesOfCompany);
                this.props.getCommonAndUnaffectedEquipments(this.props.activeUser, this.props.loggedEmployee);
            }           
        }            
    }

    loadList(value) {
        if (this.props.myEquipmentsEPI.length == 0 && !value) {
            this.props.getMyEquipmentsEPI(this.props.activeUser);
        }

        if (value) {
            if (this.props.coworkersEquipmentsEPI.length == 0) {
                this.props.getCoworkersEquipmentsEPI(this.props.activeUser, this.props.employeesOfCompany);
            }
    
            if (this.props.commonAndUnaffectedEquipments.length == 0) {
                this.props.getCommonAndUnaffectedEquipments(this.props.activeUser, this.props.loggedEmployee);
            }
        }        
    }

    handleChange = (event, value) => {
        this.loadList(value);
        this.props.setEquipmentsEPITabId(value);
    };

    handleChangeIndex = (index) => {
        this.loadList(index);
        this.props.setEquipmentsEPITabId(index);
    };

    render() {
        let views = [
            <MyEquipmentsEPI key="0" {...this.props} />,
            <EquipmentsEPI key="1" {...this.props} />
        ]

        let tabs = [
            <Tab key="0" label={"Mes équipements"} style={{height: '60px'}} />,
            <Tab key="1" label={"Équipements de l'équipe"} style={{height: '60px'}} />
        ];

        return (
            <div  className="main-div flex-div">
                <AppBar position="static" color="default">
                    <Tabs
                        value={this.props.tabId}
                        onChange={this.handleChange}
                        variant="fullWidth"
                        scrollButtons="auto"
                        indicatorColor="primary"
                        textColor="primary"
                    >
                        {tabs}
                    </Tabs>
                </AppBar>
                <div className='swipeable-view-div'> 
                    <SwipeableViews
                        axis="x"
                        index={this.props.tabId}
                        onChangeIndex={this.handleChangeIndex}
                    >
                        {views}
                    </SwipeableViews>
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        tabId: state.equipmentsEPI.tabId,
        activeUser: state.activeUser,
        loggedEmployee: state.loggedEmployee.loggedEmployee, 
        employeesOfCompany: state.forms.employeesOfCompany,
        myEquipmentsEPI: state.equipmentsEPI.myEquipmentsEPI,
        coworkersEquipmentsEPI: state.equipmentsEPI.coworkersEquipmentsEPI,
        commonAndUnaffectedEquipments: state.equipmentsEPI.commonAndUnaffectedEquipments
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        setEquipmentsEPITabId: (selectedTab) => dispatch(setEquipmentsEPITabId(selectedTab)),
        getEmployeesByDepartment: (departmentIds, companyIds, user) => dispatch(getEmployeesByDepartment(departmentIds, companyIds, user)),
        getMyEquipmentsEPI: (activeUser) => dispatch(getMyEquipmentsEPI(activeUser)),
        getCoworkersEquipmentsEPI: (activeUser, employeesOfCompany) => dispatch(getCoworkersEquipmentsEPI(activeUser, employeesOfCompany)),
        getCommonAndUnaffectedEquipments: (activeUser, loggedEmployee) => dispatch(getCommonAndUnaffectedEquipments(activeUser, loggedEmployee))
    };
};

export default compose(withAuth, connect(mapStateToProps, mapDispatchToProps))(FollowupEquipmentsEPI);
